import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const defaultLoggedInPath = '/dashboard';
const loggedOutPaths = [
  '/register',
  '/login',
  '/reset-password',
  '/forgot-password'
];

let loggedInPath = document.location.pathname;

if (!loggedInPath || loggedInPath === '/') {
  loggedInPath = defaultLoggedInPath;
}

for (let i = 0; i < loggedOutPaths.length; i++) {
  if (loggedInPath.indexOf(loggedOutPaths[i]) > -1) {
    loggedInPath = defaultLoggedInPath;
    break;
  }
}

if (document.location.search) {
  loggedInPath += document.location.search;
}

if (document.location.hash) {
  loggedInPath += document.location.hash;
}

const checkLogin = (props, history) => {
  if (props.authenticated) {
    history.push(loggedInPath);
  }
};

export default function(ComposedComponent) {
  class NotAuthentication extends Component {
    componentWillMount() {
      checkLogin(this.props, this.props.history);
    }

    componentWillUpdate(nextProps) {
      checkLogin(nextProps, this.props.history);
    }

    PropTypes = {
      router: PropTypes.object
    };

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      authenticated: state.login.authenticated,
      user: state.login.user
    };
  }

  return connect(mapStateToProps)(NotAuthentication);
}



// WEBPACK FOOTER //
// ./src/components/util/NoAuthComponent.js